"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Theme = _interopRequireDefault(require("../Theme"));

var _Text = _interopRequireDefault(require("../Text"));

var _propTypes = require("prop-types");
/* eslint-disable react/forbid-prop-types */


var OUT_OF_FIVE = '/5';

var ParentWrapper = _styledComponents.default.div.withConfig({
  displayName: "UserReviewsRating__ParentWrapper",
  componentId: "sc-1jor8yq-0"
})(["display:flex;flex-direction:column;border-radius:16px;box-sizing:border-box;padding-top:32px;font-family:'DM Sans';width:'100%';"]);

var TopHeader = _styledComponents.default.div.withConfig({
  displayName: "UserReviewsRating__TopHeader",
  componentId: "sc-1jor8yq-1"
})(["display:flex;justify-content:space-between;width:100%;"]);

var RatingArea = _styledComponents.default.div.withConfig({
  displayName: "UserReviewsRating__RatingArea",
  componentId: "sc-1jor8yq-2"
})(["display:flex;flex-direction:row;align-items:center;height:39px;"]);

var UserRating = _styledComponents.default.div.withConfig({
  displayName: "UserReviewsRating__UserRating",
  componentId: "sc-1jor8yq-3"
})(["display:flex;flex-direction:row;justify-content:center;align-items:center;padding:4px 10px;height:40px;color:#ffffff;font-weight:500;font-size:16px;line-height:150%;box-sizing:border-box;margin-right:12px;background:", ";border-radius:12px 12px 0px 12px;"], function (_ref) {
  var move = _ref.move;
  return move ? '#023C40' : '#4B4FA6';
});

var UserRaitingTextArea = _styledComponents.default.div.withConfig({
  displayName: "UserReviewsRating__UserRaitingTextArea",
  componentId: "sc-1jor8yq-4"
})(["height:39px;"]);

var ReadReview = _styledComponents.default.div.withConfig({
  displayName: "UserReviewsRating__ReadReview",
  componentId: "sc-1jor8yq-5"
})(["display:flex;"]);

var getStyles = function getStyles(_ref2) {
  var count = _ref2.count,
      move = _ref2.move;
  var styles;

  if (count) {
    styles = 'color: #75767a;';
  } else if (move) {
    styles = 'color: #023C40; text-decoration: underline; cursor: pointer;';
  } else {
    styles = 'color: #4B4FA6; text-decoration: underline; cursor: pointer;';
  }

  return styles;
};

var UserReviewTitel = _styledComponents.default.div.withConfig({
  displayName: "UserReviewsRating__UserReviewTitel",
  componentId: "sc-1jor8yq-6"
})(["height:18px;font-weight:500;font-size:12px;line-height:150%;color:#75767a;margin-right:4px;", ";"], function (_ref3) {
  var count = _ref3.count,
      move = _ref3.move;
  return getStyles({
    count: count,
    move: move
  });
});

var HorizontalBar = _styledComponents.default.div.withConfig({
  displayName: "UserReviewsRating__HorizontalBar",
  componentId: "sc-1jor8yq-7"
})(["border-bottom:1px solid lightgrey;margin:12px 12px 0 0;"]);

var IndividualRatingArea = _styledComponents.default.div.withConfig({
  displayName: "UserReviewsRating__IndividualRatingArea",
  componentId: "sc-1jor8yq-8"
})(["display:flex;flex-wrap:wrap;width:100%;margin:8px 0;"]);

var Ratings = _styledComponents.default.div.withConfig({
  displayName: "UserReviewsRating__Ratings",
  componentId: "sc-1jor8yq-9"
})(["height:21px;width:40px;border:1px solid ", ";color:", ";border-radius:4px;padding:4px;margin:8px 0;"], function (_ref4) {
  var move = _ref4.move;
  return move ? '#023C40' : '#4B4FA6';
}, function (_ref5) {
  var move = _ref5.move;
  return move ? '#023C40' : '#4B4FA6';
});

var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "UserReviewsRating__Wrapper",
  componentId: "sc-1jor8yq-10"
})(["display:flex;flex-direction:column;", ""], function (_ref6) {
  var isMobile = _ref6.isMobile,
      handleReadReview = _ref6.handleReadReview;
  return "width: ".concat(isMobile || handleReadReview ? "33%" : '50%', ";");
});

var UserReviewsRating = function UserReviewsRating(_ref7) {
  var isMobile = _ref7.isMobile,
      rating = _ref7.rating,
      count = _ref7.count,
      readReviews = _ref7.readReviews,
      ratingLabel = _ref7.ratingLabel,
      individualRatings = _ref7.individualRatings,
      handleReadReview = _ref7.handleReadReview,
      theme = _ref7.theme,
      move = _ref7.move;
  var elements = individualRatings.filter(function (element) {
    return element !== null;
  });

  var getRating = function getRating(reviewRating, text) {
    return /*#__PURE__*/_react.default.createElement(Wrapper, {
      isMobile: isMobile,
      handleReadReview: handleReadReview
    }, /*#__PURE__*/_react.default.createElement(Ratings, {
      theme: theme,
      move: move
    }, reviewRating + OUT_OF_FIVE), /*#__PURE__*/_react.default.createElement(_Text.default, {
      Theme: theme,
      marginTop: "tiny",
      color: "greyDarker",
      type: "textSmall",
      bold: true,
      customProperties: {
        fontWeight: 400,
        lineHeight: '150%'
      }
    }, text));
  };

  return /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(ParentWrapper, null, /*#__PURE__*/_react.default.createElement(TopHeader, null, /*#__PURE__*/_react.default.createElement(RatingArea, null, /*#__PURE__*/_react.default.createElement(UserRating, {
    theme: theme,
    move: move
  }, rating + OUT_OF_FIVE), /*#__PURE__*/_react.default.createElement(UserRaitingTextArea, null, /*#__PURE__*/_react.default.createElement(_Text.default, {
    Theme: theme,
    color: "neutral",
    type: "normal",
    bold: true,
    customProperties: {
      fontWeight: 500,
      lineHeight: '150%',
      marginTop: '8px'
    }
  }, ratingLabel), /*#__PURE__*/_react.default.createElement(ReadReview, null, /*#__PURE__*/_react.default.createElement(UserReviewTitel, {
    color: "#75767a",
    count: true,
    move: move
  }, count), handleReadReview && /*#__PURE__*/_react.default.createElement(UserReviewTitel, {
    color: move ? '#C82828' : '#4B4FA6',
    move: move,
    onClick: handleReadReview
  }, readReviews))))), /*#__PURE__*/_react.default.createElement(HorizontalBar, null), elements && elements.length >= 2 && /*#__PURE__*/_react.default.createElement(IndividualRatingArea, null, elements.map(function (element) {
    return (element === null || element === void 0 ? void 0 : element.key) && getRating(element === null || element === void 0 ? void 0 : element.value, element === null || element === void 0 ? void 0 : element.key);
  }))));
};

UserReviewsRating.propTypes = {
  isMobile: _propTypes.bool,
  rating: _propTypes.string,
  ratingLabel: _propTypes.string,
  count: _propTypes.string,
  readReviews: _propTypes.string,
  individualRatings: _propTypes.array,
  handleReadReview: _propTypes.func,
  theme: _propTypes.string,
  move: _propTypes.bool
};
UserReviewsRating.defaultProps = {
  isMobile: false,
  rating: '',
  ratingLabel: '',
  count: '',
  readReviews: 'Read reviews',
  individualRatings: [],
  handleReadReview: null,
  theme: 'AIRASIA_CLASSIC',
  move: false
};
var _default = UserReviewsRating;
exports.default = _default;